/* eslint-disable array-element-newline, max-len */
/* eslint-disable react/jsx-no-bind */
import React, {useEffect, useRef, useState} from "react";
import PropTypes from "prop-types";

const Notification = ({
  modalClassAddition,
  modalHideSpeed,
  notificationDisplayIconClass,
  notificationDisplayText,
  notificationDisplayType,
  setNotificationDisplayText,
  setNotificationDisplayType
}) => {
  const [showNotification, setShowNotification] = useState(true);
  const notificationRef = useRef(null);
  const timeoutRef = useRef(null);
  const statusDependentNotification = ["Sit back and relax", "Your set will ship in"];

  const isStatusDependentNotification = () => statusDependentNotification.some(
    phrase => notificationDisplayText.includes(phrase)
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowNotification(false);
    }, modalHideSpeed);

    return () => clearTimeout(timer);
  }, [modalHideSpeed]);


  useEffect(() => {
    if (isStatusDependentNotification) {
      const hasNotificationBeenShown = localStorage.getItem("notificationShown");
      if (!hasNotificationBeenShown) {
        localStorage.setItem("notificationShown", "true");
      } else if (setNotificationDisplayText) {
        setNotificationDisplayText("");
      }
    }
    if (!showNotification && notificationDisplayType) {
      setNotificationDisplayType("");
    }
  }, [notificationDisplayText, showNotification]);

  useEffect(() => {
    setShowNotification(Boolean(notificationDisplayType));

    if (notificationDisplayType) {
      timeoutRef.current = setTimeout(() => {
        setNotificationDisplayType("");
      }, modalHideSpeed);
    } else {
      clearTimeout(timeoutRef.current);
    }
  }, [notificationDisplayType]);

  const handleCloseNotification = () => {
    setShowNotification(false);
  };

  const handleClickOutside = (event) => {
    if (notificationRef.current && !notificationRef.current.contains(event.target)) {
      setShowNotification(false);
    }
  };

  const handleClickViewCart = () => {
    setShowNotification(false);
    document.querySelector(".cart-icon-button").click();
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div className="toast-notifications">
      {notificationDisplayText && !notificationDisplayType &&
      <div
        className={`preview-swap-notification show ${modalClassAddition}${showNotification ? "show" : ""}`}
        onClick={handleCloseNotification}
        ref={notificationRef}
      >
        <span className={notificationDisplayIconClass} />
        <span>
          {notificationDisplayText}
        </span>
      </div>}

      {notificationDisplayType === "itemAddedToCart" &&
      <div
        className={`toast-notification-success${showNotification ? " show" : ""} ${modalClassAddition}`}
        onClick={handleClickViewCart}
        ref={notificationRef}
      >
        <div className="flex gap-4 justify-start items-center leading-4">
          <i className="fa-light fa-check" />
          <div>
            Added to cart.
            {" "}
            <span className="font-sans-bold underline">
              Ready to checkout?
            </span>
          </div>
        </div>
      </div>}

      {notificationDisplayType === "itemSoldOut" &&
      <div
        className={`toast-notification-danger${showNotification ? " show" : ""} ${modalClassAddition}`}
        onClick={handleCloseNotification}
        ref={notificationRef}
      >
        <div className="flex gap-4 justify-start items-center leading-4">
          <i className="fa-solid fa-face-sad-tear" />
          <div>
            Oh no! Not enough left in our inventory...
          </div>
        </div>
      </div>}
    </div>
  );
};

Notification.defaultProps = {
  "modalClassAddition": "",
  "modalHideSpeed": 6000,
  "notificationDisplayIconClass": "",
  "notificationDisplayText": "",
  "notificationDisplayType": "",
  "setNotificationDisplayText": null,
  "setNotificationDisplayType": null
};

Notification.propTypes = {
  "modalClassAddition": PropTypes.string,
  "modalHideSpeed": PropTypes.number,
  "notificationDisplayIconClass": PropTypes.string,
  "notificationDisplayText": PropTypes.string,
  "notificationDisplayType": PropTypes.oneOf(["", "itemAddedToCart", "itemSoldOut"]),
  "setNotificationDisplayText": PropTypes.func,
  "setNotificationDisplayType": PropTypes.func
};

export default Notification;
